import React from "react";

export const OpenPlatformAccessTokenContext = React.createContext("");

export const useOpenPlatformAccessToken = () =>
  React.useContext(OpenPlatformAccessTokenContext);
